<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProductoCuponDescuento"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductDiscountCodesModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionProductDiscountCodesModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.codigo }}</b>
          {{ $t('mEditionProductDiscountCodesModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mEditionProductTrackingCodesModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductDiscountCodesModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductDiscountCodesModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductDiscountCodesModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteProductoCuponDescuento () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProductoCuponDescuento', {}, [this.$route.params.id, this.$modal.element.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductDiscountCodesModalDelete', 'deleteProductoCuponDescuento', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductDiscountCodesModalDelete', 'deleteProductoCuponDescuento', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
